// removed by extract-text-webpack-plugin
module.exports = {"page-header":"page-header__3MB3h"};


//////////////////
// WEBPACK FOOTER
// ./app/scripts/views/App/components/PageHeader/styles.scss
// module id = ./app/scripts/views/App/components/PageHeader/styles.scss
// module chunks = 1